import { PdsWidget } from './pds-widget';
import { pdsI18n } from './pds-i18n';

export class PdsFormatNumber extends PdsWidget {
  is = 'pds-format-number';
  dataNumber: string | null;
  number: number | null;
  dataNumberDecimals: string | null;
  numberDecimals: number | null;
  localizedNumber: string;

  properties = {
    dataNumber: {
      type: String,
      value: null,
      observer: 'updateNumber'
    },
    number: {
      type: Number,
      value: null,
      observer: 'localizeNumber'
    },
    dataNumberDecimals: {
      type: String,
      value: null,
      observer: 'updateDecimalNumber'
    },
    numberDecimals: {
      type: Number,
      value: null,
      observer: 'localizeNumber'
    },
    localizedNumber: {
      type: String,
      value: null,
      readOnly: true
    }
  };

  updateNumber(): void {
    if (this.dataNumber != null && this.dataNumber !== '') {
      let isValidNumber = !isNaN(this.dataNumber as any as number);

      if (isValidNumber === true) {
        this.number = Number(this.dataNumber);
      } else {
        this.number = null;
      }
    } else {
      this.number = null;
    }
  }

  updateDecimalNumber(): void {
    if (this.dataNumberDecimals != null && this.dataNumberDecimals !== '') {
      let isValidNumber = !isNaN(this.dataNumberDecimals as any as number);

      if (isValidNumber === true) {
        this.numberDecimals = Number(this.dataNumberDecimals);
      } else {
        this.numberDecimals = null;
      }
    } else {
      this.numberDecimals = null;
    }
  }

  localizeNumber(): void {
    let theNewValue: string = pdsI18n.localizeNumber(this.number, this.numberDecimals);
    this.setPrivatePolymerPropertyValue('localizedNumber', theNewValue);
  }
}
